import { render, staticRenderFns } from "./gas-db.component.vue?vue&type=template&id=3e334b70"
import script from "./gas-db.component.ts?vue&type=script&lang=ts&external"
export * from "./gas-db.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports